import { useEffect, useMemo, useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { drawerWidth, headerHeight } from "./../../config"
// material-ui
import { useTheme } from "@mui/material/styles"
import { Box, Toolbar, useMediaQuery, Divider } from "@mui/material"

// project import
import Drawer from "./Drawer"
import Header from "./Header"
import NAVIGATION from "menu-items"
import Breadcrumbs from "components/@extended/Breadcrumbs"
import DrawerHeader from "./Drawer/DrawerHeader"

// types
import { openDrawer } from "store/reducers/menu"
import zIndex from "@mui/material/styles/zIndex"

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme()
  const matchDownLG = useMediaQuery(theme.breakpoints.down("lg"))
  const dispatch = useDispatch()
  const { isLogin, user } = useSelector((state) => state.user)
  const [navigationItems, setNavigationItems] = useState(NAVIGATION)
  const navigation = useLocation()
  const isAdminRoute = navigation.pathname.split("/").includes("admin")
  const navbarCommonStyle = useMemo(() => {
    return {
      borderRight: "none",
      boxShadow: theme.customShadows.z1,
      backgroundColor: theme.palette.primary["darker"],
      color: theme.palette.primary["contrastText"],
      zIndex: 10,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }
  }, [theme])
  useEffect(() => {
    if (isLogin) {
      let items = navigationItems?.items?.filter(
        (item) => item.id !== "authentication"
      )
      //filtering  admin routes
      if (user.userType == 3) {
        //removing dashboard paths
        items = items?.filter((item) => item.id !== "dashboard")
      } else {
        items = items?.filter((item) => item.id !== "admin")
      }

      setNavigationItems({ items: items })
    } else {
      setNavigationItems(NAVIGATION)
    }
  }, [isLogin])

  const { drawerOpen } = useSelector((state) => state.menu)

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen)
  const handleDrawerToggle = () => {
    setOpen(!open)
    dispatch(openDrawer({ drawerOpen: !open }))
  }

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG)
    dispatch(openDrawer({ drawerOpen: !matchDownLG }))
  }, [matchDownLG])

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen)
  }, [drawerOpen])

  return (
    <Box
      sx={{
        display: "grid",
        width: "100svw",
        gridTemplateRows: `${headerHeight}  calc(100svh - ${headerHeight}  ) `,
        gridTemplateColumns: open
          ? `${drawerWidth} repeat(11, 1fr)`
          : "repeat(12,1fr)",
        alignContent: "stretch",
        overflow: "scroll",
      }}
    >
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />

      {/* ---------Drawer start -------- */}
      <Box
        sx={{
          ...navbarCommonStyle,

          gridColumn: open ? 1 : 0,
          display: open ? "block" : "none",
          gridRow: "1 ",
        }}
      >
        <DrawerHeader />
      </Box>
      <Box
        sx={{
          gridRow: "1 / 1",
          gridColumn: "1 / 1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
      >
        <Divider
          sx={{
            width: "80%",
            mx: "auto",
            zIndex: 10,
            // height: "1em",
            bgcolor: "red",
          }}
        />{" "}
      </Box>

      <Box
        sx={{
          ...navbarCommonStyle,

          gridColumn: open ? 1 : 0,
          display: open ? "block" : "none",
          gridRow: "2 / 3",
          pt: 3,
        }}
      >
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
      </Box>

      {/* ---------Drawer end -------- */}

      <Box
        className="no-scrollbar"
        sx={{
          height: "100%",
          width: "100%",
          gridColumn: {
            xs: "1/13",
            md: open ? "2 / 13" : "1 / 13",
          },
          gridRow: 2,
          p: { xs: 1, sm: 3 },
          pt: { sm: 5 },
          overflow: "auto",
          backgroundColor: "white",
        }}
      >
        <Outlet />
      </Box>
      {/* <Box
        component="main"
        sx={{
          width: "1000%",
          flexGrow: 1,
     
          bgcolor: "rgba(10,244,99,0.4)",
        }}
      > */}
      {/* <Toolbar /> */}
      {/* <Breadcrumbs navigation={navigationItems} title /> */}
      {/* </Box> */}
    </Box>
  )
}

export default MainLayout
